import { useLocation } from 'react-router-dom';
import { PATH_ROOT } from '@/routes/paths';

/**
 * Returns true when the current route is under /demo/*.
 * Use this to pick demo vs prod paths for navigation:
 *
 *   const isDemo = useIsDemo();
 *   navigate(isDemo ? PATH_ROOT.demo.vault : PATH_ROOT.main.vault);
 */
export function useIsDemo(): boolean {
  const { pathname } = useLocation();
  return pathname.startsWith(PATH_ROOT.demo.root);
}

/**
 * Picks the demo or prod path based on the current route context.
 *
 *   const paths = useDemoPaths();
 *   navigate(paths.calendar);  // → /demo/calendar or /calendar
 */
export function useDemoPaths() {
  const isDemo = useIsDemo();
  return isDemo ? PATH_ROOT.demo : PATH_ROOT.main;
}
